<template>
  <div class="d-flex">
    <div class="col-md-3">
        <PanelTravelAdvance :Situacao="Situacao" @refreshLogAdvance="refreshLogAdvance" :dataDetails="dataDetails"></PanelTravelAdvance>
    </div>
    <div class="col-md-9">
        <FormDetailsAdvance @carregaSituacao='carregaSituacao' ref="FormDetailsAdvance"  :dataDetails="dataDetails" @voltarPersonalizado="$emit('voltarPersonalizado')"></FormDetailsAdvance>
    </div>
  </div>
</template>

<script>
import DetailsTravelAdvanced from './DetailsTravelAdvanced'
export default DetailsTravelAdvanced
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/DetailsTravelAdvanced/DetailsTravelAdvanced.vue